export const TRUSTED_HANDLER_EVENT = 'TRUSTED_HANDLER_EVENT';
export const PARENT_APP_IFRAME_ID = 'timezone-crossover-iframe';

export const HAS_PARENT_APP = window.top !== window.self;
